import PropTypes from 'prop-types';

const ButtonRed = ({ children, onClick, ...property }) => (
  <button
    className={` flex items-center justify-center focus:outline-none hover:opacity-95 transition-all duration-150 ease-linear shadow outline-none hover:shadow-lg bg-primary-500 rounded-lg   font-medium leading-7 text-center text-white px-12 py-3 ${property.className} `}
    onClick={onClick}
  >

    {children}
  </button>
);
export default ButtonRed;

ButtonRed.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.string,
  className: PropTypes.string
};
